export default "__VITE_ASSET__0b52c93f__"